export default __webpack_public_path__ + "static/media/virtual-bg1.326da348.png";